export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        _name: "CSidebarNavItem",
        name: "Pacientes",
        to: "/pacientes",
        icon: "cil-people",
        // items: [
        //   {
        //     name: "Listagem",
        //     to: "/pacientes",
        //   },
        // ],
        localStorage,
      },
      {
        _name: "CSidebarNavItem",
        name: "Calendario",
        to: "/calendario/listar",
        icon: "cil-calendar",
        // items: [
        //   {
        //     name: "Listagem",
        //     to: "/calendario/listar",
        //   },
        // ],
      },
      {
        _name: "CSidebarNavItem",
        name: "Consulta",
        to: "/consultas",
        icon: "cil-flag-alt",
        // items: [
        //   {
        //     name: "Listagem",
        //     to: "/consultas",
        //   },
        // ],
      },
      {
        _name: "CSidebarNavItem",
        name: "Profissionais",
        to: "/profissionais",
        icon: "cil-user",
        // items: [
        //   {
        //     name: "Listagem",
        //     to: "/profissionais",
        //   },
        // ],
      },
    ],
  },
];
